import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "body"]

  connect() {
    // assume fechado por padrão se body tiver hidden
    this.sync()
  }

  toggle() {
    this.bodyTarget.classList.toggle("hidden")
    this.sync()
  }

  sync() {
    const isOpen = !this.bodyTarget.classList.contains("hidden")

    this.headerTarget.classList.toggle("bg-gray-50", !isOpen)
    this.headerTarget.classList.toggle("border-gray-200", !isOpen)
    this.headerTarget.classList.toggle("text-gray-700", !isOpen)

    this.headerTarget.classList.toggle("bg-white", isOpen)
  }
}
